export default __webpack_public_path__ + "static/media/podium.d84a1d63.svg";